import { useSelector } from 'react-redux';
import { selectHasCatalogProducts } from 'selectors/productsCartSelectors';

/**
 * useHasCatalogProducts hook.
 * Checks if the catalog has products available for a specific segment.
 * Useful for conditionally displaying catalog-related UI elements.
 *
 * @param {string} segment - Segment of the journey: 'outgoing', 'incoming', or 'both' to check either segment
 * @returns {boolean} True if catalog has products for the segment(s), false otherwise
 */
export const useHasCatalogProducts = (segment = 'outgoing') => {
  const hasOutgoing = useSelector(selectHasCatalogProducts('outgoing'));
  const hasIncoming = useSelector(selectHasCatalogProducts('incoming'));

  // Return based on segment: 'both' checks if either has products, otherwise check specific segment
  if (segment === 'both') {
    return hasOutgoing || hasIncoming;
  }

  return segment === 'outgoing' ? hasOutgoing : hasIncoming;
};

export default useHasCatalogProducts;
